module.exports = __webpack_public_path__ + "img/login_corporativ.ee91bc93.svg";